<template>
  <div>
    <mt-popup v-model="isNavShow" position="left">
      <div class="navBar">
        <template v-for='item in categoryList'>
          <div class="cell_wrap left_menu_title">
            <router-link :to="'/list/?bid='+item.bid">
                            <span class="title">
                                {{item.bname}}
                                <i v-if="item.num>99" class="num">99+</i>
                                <i v-else class="num">{{item.num}}</i>
                            </span>
            </router-link>
          </div>
          <div v-if="item.list.length > 0">
            <div class="left_menu_sub" @click="showFlavor=!showFlavor">
              <span class="title">
                口味筛选
              </span>
              <span :class="{iconsfont:true, 'icons-arrowdown':showFlavor, 'icons-arrowup':!showFlavor}"></span>
            </div>
            <div v-show="showFlavor">
              <template v-for='vo in item.list'>
                <router-link :to="'/list/?bid='+item.bid+'&fid='+vo.tid" tag="div" class="cell_wrap">
                  <div class="left_menu">
                    <div class="icon_wrap">
                      <i :icon='vo.class'></i>
                    </div>
                    <span class='itemName'>
                      {{vo.tname}}
                      <!--<i v-if="vo.num>99" class="num">99+</i>
                      <i v-else class="num">{{vo.num}}</i>-->
                    </span>
                  </div>
                </router-link>
              </template>
            </div>
          </div>
          <div v-if="item.scene.length > 0">
            <div class="left_menu_sub" @click="showScene=!showScene">
                <span class="title">
                  场景筛选
                </span>
              <span :class="{iconsfont:true, 'icons-arrowdown':showScene, 'icons-arrowup':!showScene}"></span>
            </div>
            <div v-show="showScene">
              <template v-for='vo in item.scene'>
                <router-link :to="'/list/?bid='+item.bid+'&sid='+vo.tid" tag="div" class="cell_wrap">
                  <div class="left_menu">
                    <div class="icon_wrap">
                      <span :class="'iconsfont icons-' + vo.class"></span>
                    </div>
                    <span class='itemName'>
                      {{vo.tname}}
                      <!--<i v-if="vo.num>99" class="num">99+</i>
                      <i v-else class="num">{{vo.num}}</i>-->
                    </span>
                  </div>
                </router-link>
              </template>
            </div>
          </div>
        </template>
      </div>
    </mt-popup>
    <div class="footer" ref="footer">
      <ul>
        <router-link to="/home" tag="li" class="li-1">
          <span>首页</span>
        </router-link>
        <!-- <li class="li-1" :class='{on:navName=="home"}' @click="isNavShow = false; navNameFun('home')">
          <span>首页</span>
        </li> -->
        <em></em>
         <router-link to="/cake" tag="li" class="li-2">
           <span>分类</span>
        </router-link>
        <em></em>

        <!-- <li class="li-3" :class='{on:navName=="cart"}' @click="isNavShow = false; navNameFun('cart')">
          <router-link :to="{ name: 'cart'}" tag="span">购物车
            <i class="icon-badge" v-if='cartNum>0&&cartNum<100'><b>{{cartNum}}</b></i>
            <i class="icon-badge" v-if='cartNum>=100'><b>99+</b></i>
          </router-link>
        </li>
        <em></em>
         <li class="li-4" :class='{on:navName=="users/index"}' @click="isNavShow = false; navNameFun('users/index')">
          <router-link to="/users/index" tag="span">我的</router-link>
        </li> -->



        <router-link to="/cart" tag="li" class="li-3">
          <span>购物车
            <i class="icon-badge" v-if='cartNum>0&&cartNum<100'><b>{{cartNum}}</b></i>
            <i class="icon-badge" v-if='cartNum>=100'><b>99+</b></i>
          </span>
        </router-link>
        <em></em>
         <router-link to="/users/index" tag="li" class="li-4">
          <span>我的</span>
       </router-link>

      </ul>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'foot',
    data () {
      return {
        msg: '尾部导航',
        isNavShow: false,
        categoryList: [],
        cartList: [],
        cartNum: 0,
        showScene: false,
        showFlavor: false,
        navName:'',
        icons: ['navIcon icon iconsfont icons-nav-napolun', 'navIcon icon iconsfont icons-nav-nai', 'navIcon icon iconsfont icons-nav-ms',
          'navIcon icon iconsfont icons-nav-zs', 'navIcon icon iconsfont icons-cake', 'navIcon icon iconsfont icons-nav-kafa', 'navIcon icon iconsfont icons-nav-jiaguo', 'navIcon icon iconsfont icons-nav-food', 'navIcon icon iconsfont icons-nav-bjl']
      }
    },
    props: ['msgFather', 'clear', 'num'],
    mounted () {
      this.getCategoryList();
      let vheight = this.$refs.footer.offsetHeight;
      this.$emit("getHeight",vheight);

    },
    computed: {},
    activated () {
      this.getCartList()
    },
    watch: {
      'clear.num': {
        handler (newValue, oldValue) {
          if (oldValue != 0) {
            this.getCartList()
            this.isNavShow = false
          }
        },
        deep: true
      },
      'num.num': {
        handler (newValue, oldValue) {
          this.getCartList()
          this.isNavShow = false
        },
        deep: true
      },
      '$route': function () {
        this.isNavShow = false
      }
    },
    methods: {
      ...mapActions({
        add: 'addCart' // 将 `this.add()` 映射为 `this.$store.dispatch('increment')`
      }),
      navNameFun(type) {
        this.navName = type;
        console.log(this.navName)
        //this.$router.push('/' + type);
      },
      getCartList () {
        let self = this
       /* if (!mcake.isLogin()) {
          self.cartNum = ''
          return false
        } */
        self.cartList = []
        self.detailData = ''
        self.$http.get(self.host + '/api/f603064b20096f6c', {
         params: {
           cityId: store.get('city_id') ? store.get('city_id') : 110,
           uid: window.cookie.get('_uid') ? window.cookie.get('_uid') : 0
         }
        }).then(function (res) {
          self.ismounted = false
          if (res.code == 1) {
            self.cartNum = res.data.num
            self.add(self.cartNum)
          }
        }, function (error) {
          console.log(error)
        })
      },
      filter (id) {
        this.isNavShow = false
        this.$router.push('/list/' + id)
      },
      navToggle: function (event) {
      },
      getCategoryList () {
        if (store.get('city_id')) {
          var self = this
          self.$http.get(self.host + '/api/5e90690f0e270d04', {
            params: {
              cityId: store.get('city_id')
            }
          }).then(function (res) {
            if (res.code == 1) {
              self.categoryList = res.data
            }
            self.isload = true
          }, function (error) {
            console.log(error)
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .router-link-exact-active {
    font-weight: bold;
  }

  .left_menu_title {
    border-bottom: 1px solid #dddddd;
    padding-left: .4rem;
    color: #000;
    font-size: .32rem;
    line-height: 1rem;
  }

  .left_menu_title span.title {
    padding: 0 .2rem;
  }

  .navBar i.num {
    border-radius: 100%;
    min-width: .5rem;
    height: .5rem;
    line-height: .5rem;
    margin-left: .1rem;
    background: #ffe32a;
    text-align: center;
    display: inline-block;
  }

  .left_menu span.iconsfont {
    color: #000000;
    font-weight: bold;
  }

  .left_menu_sub{
    padding-left: .6rem;
    color: #333333;
    font-size: .32rem;
    line-height: 1rem;
    border-bottom: 1px #dddddd dashed;
  }

  .left_menu_sub .title{

  }

  .left_menu_sub .iconsfont{
    margin-left: .1rem;
  }
  .footer span{
    display: block;
  }
  .footer .img{
    width: 0.7rem;
    height: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue